const TONES: Record<string, string> = {
  in: 'bg-vert-fond text-vert-texte',
  low: 'bg-ambre-fond text-ambre-texte',
  out: 'bg-rouge-fond text-rouge-texte',
  ok: 'bg-vert-fond text-vert-texte',
  warn: 'bg-ambre-fond text-ambre-texte',
  bad: 'bg-rouge-fond text-rouge-texte',
  neutral: 'bg-gris-fond text-second-admin',
  published: 'bg-vert-fond text-vert-texte',
  draft: 'bg-ambre-fond text-ambre-texte',
  archived: 'bg-gris-fond text-second-admin',
}

export function StatusPill({
  label,
  tone = 'neutral',
}: {
  label: string
  tone?: string
}) {
  return <span className={`status-pill ${TONES[tone] ?? TONES.neutral}`}>{label}</span>
}
